import { Controller } from "@hotwired/stimulus";
import { chartJsFor, injectCountLine, scheduleWhenReady } from "../../helpers/chartkick_chart.js";

export default class extends Controller {
  static values = {
    chartId: String,
    sampleData: Object,
    label: String,
  };

  connect() {
    this.timeouts = [];
    scheduleWhenReady(this.chartIdValue, () => this.inject(), this.timeouts);
  }

  disconnect() {
    this.timeouts.forEach((id) => clearTimeout(id));
  }

  reinject() {
    this.inject();
  }

  inject() {
    const chart = chartJsFor(this.chartIdValue);
    if (!chart?.data?.labels) return false;

    const labels = chart.data.labels;
    const sampleData = this.sampleDataValue || {};
    if (!labels.some((label) => Object.prototype.hasOwnProperty.call(sampleData, label))) {
      return false;
    }

    const values = labels.map((label) => sampleData[label] || 0);
    injectCountLine(chart, {label: this.labelValue, values});
    return true;
  }
}
